import { render, staticRenderFns } from "./appendDistribute.vue?vue&type=template&id=1de51e71&scoped=true"
import script from "./appendDistribute.vue?vue&type=script&lang=js"
export * from "./appendDistribute.vue?vue&type=script&lang=js"
import style0 from "./appendDistribute.vue?vue&type=style&index=0&id=1de51e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de51e71",
  null
  
)

export default component.exports